export { default } from './CompareTemplateDifferences';
